// Version : 0.0.1
// Author : SATHISH
// LastEdit : KARTHEESWARAN
// MODFIED DATE:30-09-2025
//Last ADD : REMOVED EXCEL ACTIONS

import { docodeHexResponse } from '../../../_common/common.utils';
import DayBookType from './dayBookReport.types';

const INITIAL_STATE = {
	//DAY BOOK RESPONSE GET LIST
	getDaybookReportResponse: null,
	getDaybookReportArr: [],
};

const daybookReportReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** GET DAYBOOK DETAILS START *********************** */
		case DayBookType.GET_DAYBOOK_LIST_SUCCESS:
			return {
				...state,
				getDaybookReportResponse: action.payload,
				getDaybookReportArr: docodeHexResponse(
					action.payload,
					'GetBranchAccountDayBookKey',
				),
			};

		case DayBookType.GET_DAYBOOK_LIST_FAILURE:
			return { ...state, getDaybookReportResponse: action.payload };

		case DayBookType.GET_DAYBOOK_LIST_RESPONSE_CHANGED:
			return { ...state, getDaybookReportResponse: null };
		/** ***************** GET DAYBOOK DETAILS END *********************** */
		default:
			return state;
	}
};

export default daybookReportReducer;
